import { Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { triggerMenu } from '../../redux/dropdown/dropdown';
import { NavContainer, Line, NavSub, SpinerImg, NavLinks, HamburgerContainer } from './navigation.styles';
import theme from '../../assets/click_link.mp3';
import Dropdown from '../../components/drop-down/drop-down.component';
import { AiOutlineMenu } from 'react-icons/ai';
import blackhole from '../../assets/blackhole-icon.png'

const Navigation = () => {
  const dispatch = useDispatch();
  const Playit = () => {
    const audio = new Audio(theme);
    audio.play();
    }

  return (
    <>
      <NavContainer>
        <NavSub>
          <a href="/" onClick={Playit()}>
            <SpinerImg src={blackhole} alt="galaxy"/>
            <span>SANJA MANDIC</span>
          </a>
          <NavLinks>
            <a href= "/portfolio">Projects</a>
            <a href= "/portfolio/articles">Articles</a>
            <a href= "/portfolio/blogs">Blogs</a>
            <a href= "https://github.com/Sanja969">GitHub</a>
            <a href= "https://www.linkedin.com/in/sanja-mandic-823995a2/">LinkedIn</a>
            <a href= "https://twitter.com/SanjaMandic42">Twitter</a>
          </NavLinks>
          <HamburgerContainer onClick={() => dispatch(triggerMenu())}>
            <AiOutlineMenu />
          </HamburgerContainer>
        </NavSub>
        <Dropdown />
      </NavContainer>
      <Line><div></div></Line>


      <Outlet />
    </>
  );
}

export default Navigation;